function JoyTycoonObject(conf,confOrg) {
  myPixiElement.container.call(this);
  this.config = {
    width:0,
    height:0,
    anchor:[0.5,0.5],
    pos:[0,0],
    containerPos:[0,0],
    scaleImg:[0,0],
    id:0,
    type:"",//toy, ice, item(in the future)
    add_ids:[],
    howlong:0,
    onEnd:function(){},
    onEndOnce:false,
    background_arr:[],
    clock_pos:[5,5]
  };
  

  if(typeof confOrg !== "undefined") {
    this.config = $.extend(this.config,copyObj(confOrg));
  }
  this.config = $.extend(this.config,copyObj(conf));
  
  
  this.clock = new myPixiClock({
    texture_name:{
      hand:"clock_hand",
      face:"clock_face"
    },
    clock_color: "a3a9fa",
    pos:this.config.clock_pos,
    fillRadius:12
  });

  this.clock.alpha = 0;
  this.objectContainer=new myPixiElement.container({});
  this.objectArr=[];
  this.addChild(this.objectContainer);
  this.addChild(this.clock);
  
  // this.type_id = intval(type_id);
  this.x = this.config.pos[0];
  this.y = this.config.pos[1];
  this.setObject();
  
  this.storage={
      "busy":{mili_end:0,mili_have:0},
  };
  
}
JoyTycoonObject.prototype = Object.create(myPixiElement.container.prototype);
JoyTycoonObject.prototype = $.extend(JoyTycoonObject.prototype,{
    takeId:function(){
        return this.config.id;
    },
    takePos:function(anchor){
        return [
            this.config.containerPos[0]+this.config.pos[0]+this.width*anchor[0],
            this.config.containerPos[1]+this.config.pos[1]+this.height*anchor[1]
        ];
    },
    takeType:function(){
        return this.config.type;
    },
    setObject: function () {
        var i,bum;
        for(i=this.objectArr.lenght-1;i>=0;i--){
            bum=this.objectArr[i];
            bum.myRemove();
        }
        this.objectArr=[];
        this.objectContainer.removeChildren();
        if(this.config.background_arr.length){
            for(i in this.config.background_arr){
                this.objectContainer.addChild(new myPixiElement.img({img:this.config.background_arr[i]}));
            }
            
        }    

        if(this.config.type=="ice"){
            var spr = new myPixiElement.img({img:this.config.img,anchor:this.config.anchor,scaleTo:[this.config.width,this.config.height]});
            this.objectContainer.addChild(spr);
            this.objectArr.push(spr);
            for(i in this.config.add_ids){
                bum=this.config.add_ids[i];
                spr=new myPixiElement.img({img:"add"+bum,anchor:this.config.anchor,scaleTo:[this.config.width,this.config.height]});
                this.objectContainer.addChild(spr);
                this.objectArr.push(spr);
            }
            
        }
        else if(typeof this.config.img !== "undefined") {
            var conf={img:this.config.img,anchor:this.config.anchor};
            if(this.config.height>0 || this.config.width>0){
                conf.scaleTo=[this.config.width,this.config.height];
            }
            
          var spr = new myPixiElement.img(conf);
          this.objectContainer.addChild(spr);
          this.objectArr.push(spr);
        }

    },
  isClick:function (pos) {
    if(!this.isActive()) {
        return 0;
    }
    var opos=[this.config.pos[0]+this.config.containerPos[0],this.config.pos[1]+this.config.containerPos[1]];
    var osize=[this.width,this.height];
    if(isInRegion(pos,opos,osize,this.config.anchor)){
        return 1;
    }
    return 0;
    

  },
  isActive:function(){
      if(this.storage.busy.mili_end==0 || this.storage.busy.mili_have>=this.storage.busy.mili_end){
          return true;
      }
      return false;
    this.storage={
        "busy":{mili_end:0,mili_have:0},
    };  
  },
  makeBusy:function (howlong,onEnd) {
    if(typeof howlong=="undefined" || !howlong){
        howlong=this.config.howlong;
    }
    if(!this.isActive()){
        return false;
    }
    if(typeof onEnd=="function"){
        this.config.onEndOnce=onEnd;
    }
    this.storage.busy={mili_end:howlong*1000,mili_have:0};
    this.objectContainer.alpha = 0.5;
    
    this.clock.alpha = 1;
    this.clock.setClock(this.storage.busy.mili_have,this.storage.busy.mili_end);
    
    return true;
  },
  takeBusyHowlong:function(){
      if(this.storage.busy.mili_end==0){
          return 0;
      }
      return this.storage.busy.mili_end-this.storage.busy.mili_have;
  },
  updateTime:function (delta) {
      if(this.storage.busy.mili_end==0){
          return false;
      }
      this.storage.busy.mili_have+=delta*1000/60;
      this.clock.updateVal(this.storage.busy.mili_have);
      if(this.storage.busy.mili_have>=this.storage.busy.mili_end){
          this.storage.busy.mili_end=0;
          this.clock.alpha=0;
          this.objectContainer.alpha = 1;
          if(typeof this.config.onEndOnce=="function"){
              var oldFun=this.config.onEndOnce;
              this.config.onEndOnce=false;
              oldFun.call(this);
          }
          else{
              this.config.onEnd.call(this);
          }
          
          
      }
      
      
      
  },
  update:function (delta) {
    this.updateTime(delta);
  }
});